<script lang="ts">
  import Edit from '$icons/Edit2.svelte';
  import Bin from '$icons/ThreeDotTrash.svelte';
  import Copy from '$icons/CopyIcon.svelte';
  import Profile from '$icons/ProfileIcon.svelte';
  import ThreeDot from '$icons/ThreeDotIcon.svelte';

  import { onOutsideClick } from '$lib/actions/onOutsideClick';
  import { me } from '$stores/user.store';
  import { createEventDispatcher } from 'svelte';
  import DeletePostModal from '../CreatePost/DeletePostModal.svelte';
  import type { FPost } from 'garden-common';
  import { scale } from 'svelte/transition';

  export let threeDotIgnoredTargets: any[];
  export let isThreeDotOpened: boolean = false;
  export let btnCls = '';
  export let post: Partial<FPost<string>>;

  let deletePost: boolean = false;

  const dispatch = createEventDispatcher();

  let copyLabel = 'Copy link';
  const copyLink = () => {
    if (copyLabel === 'Copy link') {
      dispatch('CopyLink');
      console.log('Link copied')
      copyLabel = 'Link copied';
      setTimeout(() => {
        copyLabel = 'Copy link';
      }, 2000);
    }
  };
</script>

{#if deletePost}
  <DeletePostModal
    {post}
    on:ModalClose={() => {
      deletePost = false;
    }}
    on:DeletePost={() => {
      dispatch('DeletePost');
    }}
  />
{/if}

<div class="relative h-12">
  <button
    on:click={() => (isThreeDotOpened = !isThreeDotOpened)}
    class="duration-200 px-4 rounded-lg group h-full {btnCls}"
    bind:this={threeDotIgnoredTargets[0]}
  >
    <span class="group-hover:brightness-150 duration-200">
      <ThreeDot />
    </span>
  </button>

  <!-- Three dot menu -->
  {#if isThreeDotOpened}
    <div
      class="--three-dot-menu-container px-1 bg-white z-[50] absolute w-fit top-14 right-5 --updated-border rounded-xl overflow-hidden py-1"
      transition:scale|global={{ duration: 100 }}
      use:onOutsideClick={{
        cb: () => (isThreeDotOpened = false),
        ignoredTargets: threeDotIgnoredTargets
      }}
    >
      <button class="text-garden-grey-700 font-switzer whitespace-nowrap" on:click={copyLink}>
        <Copy size="24" />{copyLabel}</button
      >

      <button
        class="text-garden-grey-700 font-switzer whitespace-nowrap"
        on:click={() => dispatch('ViewProfile')}
      >
        <Profile size="24" /> View profile</button
      >

      {#if post.creator === $me?._id}
        <button
          class="text-garden-grey-700 font-switzer whitespace-nowrap"
          on:click={() => dispatch('EditPost')}
        >
          <Edit />

          Edit post</button
        >
      {/if}

      {#if $me?.isAdmin || post.creator === $me?._id}
        <button
          class="text-red-500 font-switzer whitespace-nowrap"
          on:click={() => (deletePost = true)}
          ><Bin size="24" />
          {#if $me?.isAdmin}
            Admin delete
          {:else}
            Delete
          {/if}
        </button>
      {/if}
    </div>
  {/if}
</div>

<style lang="postcss">
  .--three-dot-menu-container > button {
    @apply flex bg-white px-3 py-3 w-full items-center gap-x-3 font-medium;
    @apply hover:bg-garden-grey-100 rounded-lg;
  }

  .--three-dot-menu-container {
    box-shadow:
      0px 4px 6px -2px rgba(16, 24, 40, 0.03),
      0px 12px 16px -4px rgba(16, 24, 40, 0.08);
  }
</style>
